import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { MarketingPopupClose } from "./marketing-popup-close.component";
import { MarketingPopupContent } from "./marketing-popup-content.component";
import { popupVisual } from "./marketing-popup.types";
import type { MarketingPopupVariantProps } from "./marketing-popup.types";
export function MarketingPopupEditorialSplit(t0) {
  const $ = _c(16);
  const {
    popup,
    className,
    onClose,
    onCtaClick
  } = t0;
  let t1;
  let visual;
  if ($[0] !== className || $[1] !== popup) {
    visual = popupVisual(popup);
    t1 = cn("relative grid w-full max-w-2xl overflow-hidden rounded-md bg-surface-base-primary", visual && "tablet:grid-cols-[2fr_3fr]", className);
    $[0] = className;
    $[1] = popup;
    $[2] = t1;
    $[3] = visual;
  } else {
    t1 = $[2];
    visual = $[3];
  }
  let t2;
  if ($[4] !== onClose) {
    t2 = <MarketingPopupClose onClick={onClose} />;
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== visual) {
    t3 = visual && <div className="relative aspect-[16/9] tablet:aspect-auto"><VisualWrapper visual={visual} className="absolute inset-0 h-full w-full" visualClassName="h-full w-full" imgClassName="h-full w-full object-cover" /></div>;
    $[6] = visual;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onCtaClick || $[9] !== popup) {
    t4 = <MarketingPopupContent popup={popup} onCtaClick={onCtaClick} className="self-center p-6 tablet:p-10" />;
    $[8] = onCtaClick;
    $[9] = popup;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <article className={t1} data-testid="marketing-popup-editorial-split">{t2}{t3}{t4}</article>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}